import { MyLoadState } from "../../schemas/myload/myload.Schema";
import * as Constants from "../../utils/constants";
import produce from "immer";
import { MY_DRIVER_SHIPMENTS, MY_LOADS_BUCKET } from "../../utils/constants";

export const myLoadInitialState: MyLoadState = {
  profileImg: [],
  myLoadCardData: [],
  carrierAssigned: [],
  driverAssigned: [],
  inTransit: [],
  carrierTendered: [],
  deliveredNeedsPaperWork: [],
  deliveredWithPaperWork: [],
  myLoadCount: {
    carrierAssignedCount: 0,
    driverAssignedCount: 0,
    inTransitCount: 0,
    deliveredCount: 0,
    deliveredNeedsPaperWorkCount: 0,
    deliveredWithPaperWorkCount: 0,
    carrierTenderedCount: 0,
  },
  confirmStart: {},
  confirmStartStatusMessage: {},
  updateStop: {},
  startTrip: {},
  buy: {
    status: "",
    message: "",
  },
  shipment: [],
  delivered: [],
  isGetShipment: false,
  buyLoadResponseStatus: "",
  warningDialogMessage: "",
  capturedImage: null,
  myLoadFilterCount: {
    carrierTenderedFilterCount: null,
    carrierAssignedFilterCount: null,
    driverAssignedFilterCount: null,
    inTransitFilterCount: null,
    deliveredNeedsPaperWorkFilterCount: null,
    deliveredWithPaperWorkFilterCount: null,
  },
  totalShipmentsCount:null,
  myDriverShipments:[]
};

export default (state = myLoadInitialState, action: any) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Constants.GET_MYLOAD_CARD_DATA:
        draft.myLoadCardData = action.payload;
        break;

      case Constants.CarrierActionTypes.CONFIRM_START_INFORMATION_SUCCESS:
        draft.confirmStart = action.payload;
        break;

      case Constants.LOGOUT:
        draft.myLoadCardData = draft.carrierAssigned = draft.driverAssigned = draft.inTransit = draft.delivered = [];
        draft.myLoadCount.carrierAssignedCount = draft.myLoadCount.driverAssignedCount = draft.myLoadCount.inTransitCount = draft.myLoadCount.deliveredCount = draft.myLoadCount.deliveredNeedsPaperWorkCount = draft.myLoadCount.deliveredWithPaperWorkCount = 0;
        break;

      case Constants.CarrierActionTypes
        .CONFIRM_START_INFORMATION_STATUS_MESSAGE:
        draft.confirmStartStatusMessage = action.payload;
        break;

      case Constants.CarrierActionTypes.SHOW_WARNING_DIALOG:
        draft.warningDialogMessage = getWarningDialogMessage(action);
        break;

      case Constants.CarrierActionTypes.CLEAR_WARNING_DIALOG:
        draft.warningDialogMessage = "";
        break;

      case Constants.CarrierActionTypes
        .CLEAR_CONFIRM_START_INFORMATION_STATUS_MESSAGE:
        draft.confirmStartStatusMessage = {};
        break;

      case Constants.CarrierActionTypes.UPDATE_STOP_INFORMATION_RESPONSE:
        draft.updateStop = action.payload.data;
        break;

      case Constants.CarrierActionTypes.START_TRIP_INFORMATION_RESPONSE:
        draft.startTrip = action.payload;
        break;
      case Constants.BUYLOAD_DATA_SUCCESS:
        const payload = action.payload;
        draft.buy = payload.data.buy;
        break;
      case Constants.LOAD_CARRIERTENDERED_DATA:
        LoadsPopulation(action, draft, state, MY_LOADS_BUCKET.CARRIER_TENDERED);
        break;
      case Constants.LOAD_CARRIER_DATA:
        LoadsPopulation(action, draft, state, MY_LOADS_BUCKET.CARRIER_ASSIGNED);
        break;

      case Constants.DRIVER_ASSIGNED_DATA:
        LoadsPopulation(action, draft, state, MY_LOADS_BUCKET.DRIVER_ASSIGNED);
        break;

      case Constants.LOAD_INTRANSIT_DATA:
        LoadsPopulation(action, draft, state, MY_LOADS_BUCKET.INTRANSIT);
        break;
      case Constants.LOAD_DELIVEREDNEEDSPPWK_DATA:
        LoadsPopulation(
          action,
          draft,
          state,
          MY_LOADS_BUCKET.DELIVEREDNEEDSPPWK
        );
        break;
      case Constants.LOAD_DELIVEREDWITHPPWK_DATA:
        LoadsPopulation(
          action,
          draft,
          state,
          MY_LOADS_BUCKET.DELIVEREDWITHPPWK
        );
        break;
      case Constants.LOAD_DELIVERED_DATA:
        if (action.payload.data) {
          if (
            action.payload.pageNumber === 0 ||
            action.payload.pageNumber === undefined ||
            action.payload.pageNumber === null
          ) {
            draft.delivered = action.payload.data;
          } else {
            const mergedData = [{ ...draft.delivered }, ...action.payload.data];
            draft.delivered = mergedData;
          }
        }
        draft.myLoadCount.deliveredCount = action.payload.count;
        break;
        case Constants.LOAD_DRIVER_DATA_MANAGE_USERS:
          LoadsPopulationForManageUsers(action, draft, state, MY_DRIVER_SHIPMENTS);
        break;
      case Constants.BUYLOAD_SHIPMENT_SUCCESS:
        const getShipmentpayload = action.payload;
        draft.shipment =
          (getShipmentpayload?.data.getShipment) ||
          {};
        break;
      case Constants.BUYLOAD_REMOVE_STATUS:
        draft.buy = { status: "", message: "" };
        break;
      case Constants.isGetshipmentError:
        draft.isGetShipment = action.payload;
        break;
      case Constants.CLEARBUYLOAD_RESPONSE:
        draft.buyLoadResponseStatus = action.payload;
        break;
      case Constants.CarrierActionTypes.CLEAR_UPDATE_STOP_INFORMATION_RESPONSE:
        draft.updateStop = {};
        break;
      case Constants.STORE_CAPTURE_IMAGE:
        draft.capturedImage = action.payload;
        break;
      case Constants.REMOVE_CAPTURE_IMAGE:
        draft.capturedImage = null;
        break;
      case Constants.STORE_MYLOADS_FILTER_COUNT:
        draft.myLoadFilterCount = action.payload;
        break;
      case Constants.REMOVE_DRIVER_UNASSIGNED_LOAD: {
        if (state.driverAssigned && state.driverAssigned.length > 0) {
          const updatedLoadList = state.driverAssigned.filter(
            (load: any) => load.shipmentId !== action.payload
          );
          draft.driverAssigned = updatedLoadList;

          draft.myLoadCount.driverAssignedCount = updatedLoadList.length;
        }
        if (shipmentFilterValidation(state)) {
          const shipmentList = state.shipment.filter(
            (load: any) => load.shipmentId !== action.payload
          );
          draft.shipment = shipmentList;
        }
        break;
      }

      case Constants.GLOBAL_SEARCH_LOADS_UPDATE: {
        if (action.payload.bucket) {
          if (action.payload.bucket === MY_LOADS_BUCKET.CARRIER_TENDERED)
            draft.carrierTendered = action.payload.data;
          else if (action.payload.bucket === MY_LOADS_BUCKET.CARRIER_ASSIGNED)
            draft.carrierAssigned = action.payload.data;
          else if (action.payload.bucket === MY_LOADS_BUCKET.DRIVER_ASSIGNED)
            draft.driverAssigned = action.payload.data;
          else if (action.payload.bucket === MY_LOADS_BUCKET.INTRANSIT)
            draft.inTransit = action.payload.data;
          else if (action.payload.bucket === MY_LOADS_BUCKET.DELIVEREDNEEDSPPWK)
            draft.deliveredNeedsPaperWork = action.payload.data;
          else if (action.payload.bucket === MY_LOADS_BUCKET.DELIVEREDWITHPPWK)
            draft.deliveredWithPaperWork = action.payload.data;
        }
      }
    }
  });
const shipmentFilterValidation = (state: MyLoadState) => {
  return state.shipment && state.shipment.length > 0;
}

const getWarningDialogMessage = (action: any): string => {
  return (action.payload?.message) || "";
}
const LoadsPopulation = (action: any, draft: any, state: any, bucket: string) => {
    if (action.payload.pageNumber === 0 || action.payload.pageNumber === undefined || action.payload.pageNumber === null) {
      draft[bucket] = action.payload.data;
    }
    else {
      const mergedData = [...state[bucket], ...action.payload.data]
      draft[bucket] = mergedData;
    }
  draft.myLoadCount[`${bucket}Count`] = action.payload.count;
}
const LoadsPopulationForManageUsers = (action: any, draft: any, state: any, bucket: string) => {
  if (action.payload.pageNumber === 0 || action.payload.pageNumber === undefined || action.payload.pageNumber === null) {
    draft[bucket] = action.payload.data;
  }
  else {
    const mergedData = [...state[bucket], ...action.payload.data]
    draft[bucket] = mergedData;
  }
  draft.totalShipmentsCount = action.payload.count;
}
